/** Same labels as onboarding list (PRIVATE → Individual). */
export function formatApplicationType(t: string | undefined): string {
  const u = (t ?? '').toUpperCase();
  if (u === 'PRIVATE') return 'Individual';
  if (u === 'BUSINESS') return 'Business';
  return t?.trim() ? t : '—';
}
